<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <div class="tax-header" navTabs>
        <sbnb-page-header>
          <h2 fxFlex fxFlexAlign="left">
            <span fxFlex>Taxes</span>
          </h2>
          <div class="button__add-new-container">
            <mat-spinner *ngIf="loading" diameter="30"></mat-spinner>
            <button
              *ngIf="!loading"
              fxFlex
              fxFlexAlign="right"
              type="submit"
              mat-flat-button
              class="button__small button__add-new"
              data-intercom-target="direct-tax-add-new"
              [routerLink]="['/settings/taxes/name']">
              <span class="button__add-new-text__desktop">+ Add new</span>
              <span class="button__add-new-text__mobile">+</span>
            </button>
          </div>
        </sbnb-page-header>
      </div>
      <div class="tax-header">
        <h2 fxFlex fxFlexAlign="left">
          <span fxFlex>Taxes</span>
          <mat-spinner *ngIf="loading" diameter="30"></mat-spinner>
        </h2>

        <div *ngIf="!loading">
          <button
            fxFlex
            fxFlexAlign="right"
            type="submit"
            mat-flat-button
            class="button__small button__add-new"
            data-intercom-target="direct-tax-add-new"
            [routerLink]="['/settings/taxes/name']">
            + Add new
          </button>
        </div>
      </div>
    </app-feature-flag-tabs>

    <div *ngIf="loading" class="table__no-items">Loading taxes...</div>

    <ng-container *ngIf="!loading">
      <sbnb-no-items
        *ngIf="!taxes || taxes?.length === 0"
        icon="subtotal"
        text="Create and associate taxes with properties, and we’ll automatically charge them on Direct bookings"
        [buttons]="[{ id: 'new', label: 'Add your first tax' }]"
        data-intercom-target="direct-tax-add-new"
        (button)="addTax()"></sbnb-no-items>

      <ng-container *ngIf="taxes && taxes.length > 0">
        <div fxLayout fxLayoutGap="16px" fxHide.lt-md class="rules__rule-header">
          <div fxFlex>Name</div>
          <div fxFlex>Tax ID</div>
          <div fxFlex>Amount</div>
          <div fxFlex="200px">Properties</div>
          <div fxFlex="120px">&nbsp;</div>
        </div>

        <div class="invoice__container">
          <ng-container *ngFor="let tax of taxes">
            <div class="invoice" fxLayout fxLayoutAlign="start center" fxLayoutGap="16px">
              <strong fxFlex fxLayout fxLayoutGap="8px" fxLayoutAlign="start center">
                <span>{{ tax.name }}</span>
              </strong>

              <span class="text__small" fxFlex fxHide.lt-md>{{ tax.tax_identifier || 'Not provided' }}</span>

              <span class="text__small" fxFlex>
                {{ tax.value }}
                <span *ngIf="tax.charge_type === 'percent'">
                  % of
                  <ng-container *ngIf="tax.subjects?.length > 0">
                    <span *ngFor="let subject of tax.subjects; let last = last">
                      {{ subject.replace('-', ' ') }}
                      <span *ngIf="!last">,</span>
                    </span>
                  </ng-container>
                </span>
                <span *ngIf="tax.calculation_type">{{ tax.calculation_type.replace('-', ' ') }}</span>
              </span>

              <div fxFlex="200px" fxHide.lt-md>
                <sbnb-avatar-group
                  *ngIf="tax.property_list"
                  [items]="tax.property_list"
                  [itemsForLabel]="tax.name"></sbnb-avatar-group>
              </div>

              <div fxFlex="120px" fxLayoutAlign="start center" fxLayoutGap="12px">
                <button
                  (click)="update(tax)"
                  data-intercom-target="direct-tax-update"
                  class="button__small button__secondary update-button"
                  mat-flat-button>
                  <span>Update</span>
                </button>
                <sbnb-more-menu-trigger [matMenuTriggerFor]="actionsMenu"></sbnb-more-menu-trigger>
                <mat-menu #actionsMenu="matMenu">
                  <button mat-menu-item data-intercom-target="direct-tax-delete" (click)="deleteTaxPrompt(tax)">
                    <span>
                      <mat-icon inline="true">close</mat-icon>
                      <span>Delete</span>
                    </span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>
